import { render, staticRenderFns } from "./TcccSummary.vue?vue&type=template&id=6b3ac594&scoped=true&"
import script from "./TcccSummary.vue?vue&type=script&lang=ts&"
export * from "./TcccSummary.vue?vue&type=script&lang=ts&"
import style0 from "./TcccSummary.vue?vue&type=style&index=0&id=6b3ac594&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3ac594",
  null
  
)

export default component.exports